import { useNavigate, useSearchParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { DraftsController } from "./drafts-controller";
import { DraftsPage } from "./drafts-page";

/** `?bulk=1` lets other pages link straight into bulk mode. */
export function DraftsRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const bulkOpen = params.get("bulk") === "1";
  return (
    <Subtree
      key="drafts"
      controller={() =>
        new DraftsController(
          { bulkOpen },
          pick(
            deps,
            "client",
            "authHandler",
            "storeRepository",
            "providersRepository",
            "reviewQueueRepository",
            "bulkScanQueue",
          ),
          {
            reviewScan: (scanId) => navigate(`/scans/${scanId}/edit`, { state: { returnTo: "/drafts" } }),
            setBulkOpen: (open) => setParams(open ? { bulk: "1" } : {}, { replace: true }),
          },
        )
      }
    >
      <DraftsPage />
    </Subtree>
  );
}
